import { useEffect } from 'react';
import { loginRequest } from '../../config/msal';
import { InteractionStatus } from '@azure/msal-browser';
import { AuthenticatedTemplate, useMsal } from '@azure/msal-react';

import authStore from '../../store/auth';

function AuthenticatedProvider({ children }) {
  const { instance, inProgress, accounts } = useMsal();

  useEffect(() => {
    const accessTokenRequest = {
      ...loginRequest,
      account: accounts[0]
    };

    if (inProgress === InteractionStatus.None) {
      instance
        .acquireTokenSilent(accessTokenRequest)
        .then(accessTokenResponse => {
          authStore.authorize({ ...accessTokenResponse.account }, accessTokenResponse.accessToken);

          // Check if there is a "state" parameter in the URL
          const queryParams = new URLSearchParams(window.location.search);
          const originalUrl = queryParams.get('state');
          if (originalUrl) {
            // Navigate to the original URL
            window.location.replace(decodeURIComponent(originalUrl));
          }
        })
        .catch(error => {
          // If interaction is required, redirect to login
          const currentUrl = encodeURIComponent(window.location.href);

          // Add the original URL to the "state" parameter
          instance.loginRedirect({
            ...accessTokenRequest,
            state: currentUrl // Pass the current URL in the state parameter
          });
          console.log(error);
        });
    }
  }, [instance, accounts, inProgress, authStore.token]);

  return <AuthenticatedTemplate>{children}</AuthenticatedTemplate>;
}

export default AuthenticatedProvider;
